import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">
        AiSCOUT: Creating Global Opportunity for Athletes and Building Winning Teams
      </h3>
      <p className="chapter__paragraph">
        Traditionally, scouting—the process of finding new sports talent—has been a very manual,
        labor-intensive business. Scouts travel to amateur sporting events, watch players, take
        notes, and submit their reports. Scouts can’t be everywhere at once, so there’s a lot of
        luck involved in who gets scouted and plenty of worthy talent that gets overlooked.
      </p>
      <p className="chapter__paragraph">
        Imagine if an app could generate a 3D skeletal model of an athlete anywhere in the world in
        minutes and scouts could use data from that model to evaluate and source talent. This is
        literally what
        <a
          href="https://aiscout.io/"
          target="_blank"
          rel="sponsored"
          className="chapter__paragraph__link"
        >
          {' '}
          AiSCOUT
        </a>{' '}
        has achieved with a technology platform that not only benefits talented soccer athletes
        seeking their shot at the pros and the scouts trying to find them, but it also has the
        potential to change the way winning teams are built across all sports.
      </p>
    </section>
  );
}

export default Chapter3;
